export type TOnConnection = (
  root: HTMLElement,
  attributes: Record<string, string>,
  onReady: () => void
) => void;

export type TOnDisconnection<T> = (node: TRootNode<T> | null) => void;

export type TRootNode<T> = HTMLElement & { applicationNode?: T };

export function createWebComponent<T>(
  name: string,
  onConnection: TOnConnection,
  onDisconnection: TOnDisconnection<T>,
) {
  customElements.define(
    name,
    class extends HTMLElement {
      mounted: boolean;
      host: HTMLElement | null;

      constructor() {
        super();
        this.mounted = false;
        this.host = null;
      }

      connectedCallback() {
        const attributes = this.getAttributeNames().reduce(
          (obj, qualifiedName) => ({
            ...obj,
            [qualifiedName]: this.getAttribute(qualifiedName),
          }),
          {},
        );

        if (!this.mounted) {
          this.mounted = true;
          this.host = this;

          onConnection(
            this.host,
            attributes,
            () =>
              this.dispatchEvent(new Event('micro-frontend-attached')),
          );
        }
      }

      disconnectedCallback() {
        onDisconnection(this.host);
      }
    },
  );
}

export async function createApplicationContainer(node: HTMLElement) {
  const container = document.createElement('main');

  node.appendChild(container);

  return container;
}
